import { t } from "i18next";
import React, { useEffect, useState } from "react";
import AddModel from "./addModel";
import EditModel from "./editModel";
import { EquipmentModel, ProducerById } from "../../../../../types/types";
import { useAppStore } from "../../../../../stores/RootStore";
import { useFetch } from "../../../../../hooks/useFetch";
import { useEquipmentModels } from "../../../../../hooks/useFetchStateHooks/useEquipmentModels";
import _ from "lodash";
import { ColumnDef } from "@tanstack/react-table";
import { ProducerMainTabTableData } from "../../../../../types/formDataTypes";
import { DataTable } from "../../../../../ui/DataTable/DataTable";
import { Separator } from "../../../../../ui/Separator";
import { Button } from "../../../../../ui/Button";
import { SimpleDataTable } from "../../../../../ui/DataTable/SimpleDataTable";

type Props = {
  id: string | undefined;
  currentProducer: ProducerById;
};

const ProducerMainTab = ({ id, currentProducer }: Props) => {
  const equipmentTypes = useAppStore((state) => state.equipmentTypes);
  const [models, setModels] = useState<EquipmentModel[]>();

  let [isEditOpen, setIsEditOpen] = useState(false);
  let [currentItemId, setCurrentItemId] = useState("");

  function openEditModal() {
    setIsEditOpen(true);
  }

  function closeEditModal() {
    setIsEditOpen(false);
    setCurrentItemId("");
  }

  const onItemEdit = (item: ProducerMainTabTableData) => {
    setCurrentItemId(item.id);
    openEditModal();
  };

  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/equipment_models?producer_id=${id}`);

  const refreshAllModels = useEquipmentModels();
  const refreshModels = () => {
    doFetchItem();
  };

  useEffect(() => {
    refreshModels();
    //refreshAllModels();
  }, []);

  useEffect(() => {
    if (response) {
      const modelsData = response.data as unknown as EquipmentModel[];
      setModels(modelsData);
    }
  }, [response]);

  let nodes = models?.map((data) => {
    return {
      id: data?.id,
      name: data?.attributes.name,
      type_id: data.attributes.equipment_type_id,
    };
  });

  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const columns: ColumnDef<ProducerMainTabTableData>[] = [
    {
      header: t("title_name"),
      size: 1000,
      maxSize: 1000,
      minSize: 1000,
      cell: ({ row }) => <div>{row.original.name}</div>,
    },
    {
      header: t("equipment_type_name"),
      size: 300,
      maxSize: 300,
      minSize: 300,
      cell: ({ row }) => (
        <div>{equipmentTypes?.find((type) => type.id == String(row.original.type_id))?.attributes.name}</div>
      ),
    },
  ];

  return (
    <>
      <div className="flex flex-col w-full gap-8 px-6">
        {currentItemId != "" && (
          <EditModel
            id={currentItemId}
            producerId={id}
            isEditOpen={isEditOpen}
            closeModal={closeEditModal}
            refreshModels={refreshModels}
            equipmentModels={models}
          />
        )}
        <AddModel refreshModels={refreshModels} id={id} />
        
      </div>
      <SimpleDataTable data={data.nodes} columns={columns} onClickRow={onItemEdit} />
    </>
  );
};

export default ProducerMainTab;
